import L from 'leaflet';
import { HOTELS, CENTERS } from '../data.js';
import { state, priceFor } from '../state.js';
import { markerLabel } from '../i18n.js';

let map = null;
const markers = {};
let onSelect = () => {};

export function setOnSelect(fn) {
  onSelect = fn;
}

export function getMap() {
  return map;
}

export function initMap(city) {
  if (typeof L === 'undefined') {
    document.getElementById('maperr').style.display = 'flex';
    return null;
  }
  if (!map) {
    map = L.map('map', { zoomControl: false, attributionControl: true }).setView(
      CENTERS[city],
      14,
    );
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution:
        '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="https://carto.com/">CARTO</a>',
      maxZoom: 19,
      subdomains: 'abcd',
    }).addTo(map);
  }
  setTimeout(() => map && map.invalidateSize(), 120);
  return map;
}

export function panToCity(city) {
  if (map) map.setView(CENTERS[city], 14);
}

export function recenter() {
  if (map) map.setView(CENTERS[state.city], 14, { animate: true });
}

export function panToHotel(i) {
  if (map) map.panTo(HOTELS[i].ll, { animate: true });
}

export function renderMarkers() {
  if (!map) return;
  for (const id in markers) map.removeLayer(markers[id]);
  for (const id in markers) delete markers[id];

  state.filtered.forEach((i) => {
    const h = HOTELS[i];
    const p = priceFor(h);
    const icon = L.divIcon({
      className: 'pin' + (state.sel === i ? ' sel' : ''),
      html: `<span class="pin-pill">${markerLabel(p.now)}</span>`,
      iconSize: [46, 28],
      iconAnchor: [23, 28],
    });
    const m = L.marker(h.ll, { icon }).addTo(map);
    m.on('click', () => onSelect(i, true));
    markers[i] = m;
  });
}

export function invalidate() {
  if (map) map.invalidateSize();
}
